module.exports = __webpack_public_path__ + "img/collar bow width.51c171ef.png";